"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomTextField = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _CustomSearchIcon = require("./CustomSearchIcon");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * Component that renders a custom input text field
 *
 * @param {object} props
 * @returns JSX.Element
 */
var CustomTextField = function CustomTextField(_ref) {
  var params = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var classes = params.classes,
    placeholder = params.placeholder,
    loading = params.loading,
    onClick = params.onClick,
    onEnter = params.onEnter,
    iconType = params.iconType;
  var InputProps = _objectSpread(_objectSpread({}, params.InputProps), {}, {
    classes: {
      root: classes.inputRoot,
      notchedOutline: classes.notchedOutline,
      adornedEnd: classes.inputAdornedEnd
    },
    endAdornment: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loading ? /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
      color: "inherit",
      size: 20
    }) : null, params.InputProps.endAdornment, /*#__PURE__*/_react.default.createElement(_CustomSearchIcon.CustomSearchIcon, {
      classes: classes,
      onClick: onClick ? function () {
        return onClick(params.inputProps.value);
      } : undefined,
      type: iconType
    }))
  });
  var keyDown = function keyDown(event) {
    if (onEnter && event.key === 'Enter' && event.target.value) {
      onEnter(event.target.value);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_core.TextField, _extends({}, params, {
    hiddenLabel: true,
    classes: {
      root: classes.textFieldRoot
    },
    placeholder: placeholder,
    variant: "outlined",
    onKeyDown: keyDown,
    InputProps: InputProps
  }));
};
exports.CustomTextField = CustomTextField;
var _default = CustomTextField;
exports.default = _default;